import React, { useState, useEffect } from "react";
import userDetailsStyles from "../../../styles/userDetails/userDetails.module.css";
const EditTimeModal = ({ show, onClose, dayOptions, slotOptions, initial, onSave }) => {
  const [day, setDay] = useState("");
  const [time, setTime] = useState("");
  const [count, setCount] = useState(1);

  useEffect(() => {
    if (initial) {
      setDay(initial.day || "");
      setTime(initial.time || "");
      setCount(initial.count ?? 1);
    }
  }, [initial]);

  if (!show) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({ day, time, count });
  };

  return (
    <div className="modal show d-block" tabIndex="-1" role="dialog">
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Edit Time Slot</h5>
            <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">Day</label>
                <select className="form-select" value={day} onChange={(e) => setDay(e.target.value)} required disabled>
                  <option value="">Select day</option>
                  {dayOptions.map((d) => (
                    <option key={d} value={d}>{d}</option>
                  ))}
                </select>
              </div>

              <div className="mb-3">
                <label className="form-label">Time Block</label>
                <select className="form-select" value={time} onChange={(e) => setTime(e.target.value)} required disabled>
                  <option value="">Select time block</option>
                  {slotOptions.map((s, idx) => (
                    <option key={`${s.time}-${idx}`} value={s.time}>{s.time}</option>
                  ))}
                </select>
              </div>

              <div className="mb-3">
                <label className="form-label">Maximum number of appointments per time block</label>
                <select className="form-select" value={count} onChange={(e) => setCount(Number(e.target.value))} required>
                  {Array.from({ length: 8 }, (_, i) => i + 1).map((n) => (
                    <option key={n} value={n}>{n}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={onClose}>Cancel</button>
              <button type="submit" className={`btn btn-info  ${userDetailsStyles["bg-green"]}`}>Save changes</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditTimeModal;
